import { contar } from '@/lib/queueOffline';
import { useEffect, useState } from 'react';

/**
 * Hook que devuelve cuántas mutaciones pendientes hay en la cola offline.
 * Se actualiza cada 3 segundos y al recuperar conexión.
 */
export function useMutacionesPendientes(): number {
  const [pendientes, setPendientes] = useState(0);

  useEffect(() => {
    let activo = true;
    const refrescar = async () => {
      try {
        const n = await contar();
        if (activo) setPendientes(n);
      } catch {
        // IndexedDB no disponible (private mode, navegadores viejos) → 0
      }
    };

    refrescar();
    const id = setInterval(refrescar, 3_000);
    window.addEventListener('online', refrescar);

    return () => {
      activo = false;
      clearInterval(id);
      window.removeEventListener('online', refrescar);
    };
  }, []);

  return pendientes;
}
